import { BotConversation, UserConversation } from 'countable@model';
import { ConversationType } from './conversation-type.enum';
import { LoadingConversation } from './loading-coversation.interface';

export type ConversationMessage = UserConversation | BotConversation | LoadingConversation;

export function isUserConversation(message: ConversationMessage) {
  if (message?.messageType === 'USER') {
    return message as UserConversation;
  }
  return null;
}

export function isWorkflowConversation(message: ConversationMessage): message is BotConversation {
  return message.messageType === ConversationType.WORKFLOW;
}

export function isAssistantConversation(message: ConversationMessage): message is BotConversation {
  return message.messageType === ConversationType.SYSTEM;
}

export function isGeneralLedgerInputConversation(message: ConversationMessage):message is BotConversation {
  return message.messageType === ConversationType.GENERAL_LEDGER;
}

export function isLoadingConversation(message: ConversationMessage) {
  if (message?.messageType === 'LOADING') {
    return message as LoadingConversation;
  }
  return null;
}

export function conversationTypeInterface(message: ConversationMessage) {
  if (message?.messageType === ConversationType.SYSTEM || message?.messageType === ConversationType.WORKFLOW
    || message?.messageType === ConversationType.GENERAL_LEDGER) {
    return {...message} as BotConversation;
  }
  return null;
}
